<vn-am-widget [hideSkeleton]="hideSkeleton" [item]="item" [mode]="mode">
    <ng-container>
        <div class="ch__font--subtitle font-weight-bold mb-2" [innerHtml]="text"></div>
        <div class="ch__font mb-2 ch__font--description" [innerHtml]="description"></div>
    </ng-container>
</vn-am-widget>
